// extracted by mini-css-extract-plugin
module.exports = {"acordeonTitle":"styles_acordeonTitle__2g1Af","acordeonContent":"styles_acordeonContent__2KLLp"};